/**
 * VAL-INPUT-PERSIST-1D — the multiple override moves off the generic
 * multi-field "Valuation Signer overrides" box (`OverrideSection`,
 * `_IntakeDrivers.tsx`, only ever read by the deprecated `/run` path) onto
 * Intake as a single purpose-built control that round-trips through the
 * shared draft like every other Intake field.
 *
 * `OVERRIDE_DISPOSITIONS` (`core/valuation/valuation_run.py:87`) has no
 * third "accept as stated" value — an in-range override needs no
 * disposition at all, hence "Not decided yet" as the blank/null option.
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'

export function IntakeMultipleOverride({
  overrideMultiple, setOverrideMultiple,
  overrideRationale, setOverrideRationale,
  overrideDisposition, setOverrideDisposition,
}: {
  overrideMultiple: string
  setOverrideMultiple: (v: string) => void
  overrideRationale: string
  setOverrideRationale: (v: string) => void
  overrideDisposition: string
  setOverrideDisposition: (v: string) => void
}) {
  return (
    <Card>
      <CardHeader><CardTitle>Override the concluded multiple</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="override_multiple" className="text-xs">Multiple (x)</Label>
          <Input
            id="override_multiple"
            type="number"
            step="any"
            value={overrideMultiple}
            onChange={e => setOverrideMultiple(e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="override_rationale" className="text-xs">Reason</Label>
          <Textarea
            id="override_rationale"
            value={overrideRationale}
            onChange={e => setOverrideRationale(e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="override_disposition" className="text-xs">If it falls outside the signed range</Label>
          <select
            id="override_disposition"
            className="h-9 w-full rounded-md border border-pal-line-strong bg-pal-white px-2 text-sm"
            value={overrideDisposition}
            onChange={e => setOverrideDisposition(e.target.value)}
          >
            <option value="">Not decided yet</option>
            <option value="bounded">Bound it to the signed range</option>
            <option value="withdrawn">Withdraw it</option>
          </select>
          <p className="mt-1 text-xs text-pal-ink-faint">
            An override outside the signed range cannot be signed until you choose to bound or withdraw it.
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
